import Navbar from "./components/Navbar";
import Allrouts from "./routes/Allroutes";


function App() {
  return (
   <div>
    <Navbar />
    <Allrouts />   
   </div>
  );
}

export default App;
